import { Box, type BoxProps } from '@mui/material';

export const Logo = (props: BoxProps) => (
  <Box {...props}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 250 530"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M166.667,59.83c-7.828,0 -14.311,3.67 -19.448,11.009c-5.137,7.338 -7.706,17.857 -7.706,31.556c0,17.614 3.548,33.147 10.642,46.602c7.094,13.454 17.001,20.182 29.722,20.182l55.041,-0c18.592,-0 26.175,11.008 22.75,33.024c-4.403,21.528 -16.39,31.802 -35.96,30.823l-41.831,-2.201l-0,183.47c-0,17.124 2.691,30.334 8.073,39.63c5.381,9.296 11.252,14.922 17.613,16.879c6.36,1.957 12.231,5.137 17.613,9.541c5.382,4.403 8.073,10.763 8.073,19.08c-0,8.807 -2.814,14.678 -8.44,17.614c-5.626,2.935 -14.555,4.403 -26.787,4.403l-146.776,-0c-25.441,-0 -38.162,-7.828 -38.162,-23.484c0,-7.339 1.957,-13.455 5.871,-18.347c3.914,-4.893 8.073,-8.807 12.476,-11.742c4.403,-2.936 8.562,-8.929 12.476,-17.981c3.914,-9.051 5.871,-20.915 5.871,-35.593l0,-189.341l-19.081,-0.734c-10.274,-0.489 -17.98,-2.691 -23.117,-6.605c-5.137,-3.914 -6.727,-10.764 -4.77,-20.549c2.935,-18.591 15.901,-27.887 38.896,-27.887l8.072,-0c0,-50.883 13.944,-91.735 41.831,-122.559c27.888,-30.823 61.891,-46.234 102.01,-46.234c26.909,-0 49.292,7.828 67.15,23.484c17.858,15.656 26.787,36.45 26.787,62.38c-0,16.635 -4.648,28.744 -13.944,36.327c-9.296,7.584 -19.325,11.375 -30.089,11.375c-19.081,0 -33.025,-11.986 -41.831,-35.96c-9.296,-25.441 -20.304,-38.162 -33.025,-38.162Z"
        style={{
          fill: 'currentColor',
          fillRule: 'nonzero',
        }}
      />
    </svg>
  </Box>
);
